:host {
  all: initial;
  display: flex;
  flex-direction: column;
  gap: var(--zapier-grid-unit);
  color: var(--zapier-text);
  font-family: var(--zapier-font-family);
}

h2 {
  display: block;
  margin: 0;
  font-size: var(--zapier-font-size-26px);
}

h2 a {
  display: flex;
  max-width: max-content;
}

p {
  font-size: var(--zapier-font-size-14px);
  margin: 0;
}
